// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero-section {
    background: linear-gradient(to right, #007bff, #0056b3); /* Example gradient */
    min-height: 60vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .feature-card {
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }
  
  .feature-card:hover {
    transform: translateY(-10px);
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  }
  
  .blockquote-footer {
    color: #6c757d; /* Bootstrap's default secondary text color */
  }
  
  /* Add more custom styles as needed */`, "",{"version":3,"sources":["webpack://./src/pages/Home.css"],"names":[],"mappings":"AAAA;IACI,uDAAuD,EAAE,qBAAqB;IAC9E,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,qDAAqD;EACvD;;EAEA;IACE,4BAA4B;IAC5B,wDAAwD;EAC1D;;EAEA;IACE,cAAc,EAAE,6CAA6C;EAC/D;;EAEA,qCAAqC","sourcesContent":[".hero-section {\n    background: linear-gradient(to right, #007bff, #0056b3); /* Example gradient */\n    min-height: 60vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .feature-card {\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n  }\n  \n  .feature-card:hover {\n    transform: translateY(-10px);\n    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;\n  }\n  \n  .blockquote-footer {\n    color: #6c757d; /* Bootstrap's default secondary text color */\n  }\n  \n  /* Add more custom styles as needed */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
